module.exports = __webpack_public_path__ + "static/img/tbank.5c095751.svg";